import type { RemoteDisplayState } from '../domain/RemoteDisplayState.ts';
import type { TargetDisplayState } from '../domain/TargetDisplayState.ts';
import type { LegKickDisplayState } from '../domain/LegKickDisplayState.ts';
import type { IqDisplayState } from '../domain/IqDisplayState.ts';
import type { IGameRenderer } from '../ports/IGameRenderer.ts';

import { FruitNinjaCanvasLayer } from './canvas/fruit-ninja/FruitNinjaCanvasLayer.ts';
import { TargetAttackCanvasLayer } from './canvas/target-attack/TargetAttackCanvasLayer.ts';
import { LegKickCanvasLayer } from './canvas/leg-kick/LegKickCanvasLayer.ts';
import { IqCanvasLayer } from './canvas/iq/IqCanvasLayer.ts';
import { getTvQualityConfig, type TvQualityConfig } from './qualityProfile.ts';

/**
 * TV canvas: делегирует сцену Fruit Ninja, Target Attack, Leg Kick и IQ отдельным слоям;
 * общие примитивы — в `canvas/room/`.
 */
export class CanvasRenderer implements IGameRenderer {
  private readonly fruit: FruitNinjaCanvasLayer;

  private readonly target: TargetAttackCanvasLayer;

  private readonly legKick: LegKickCanvasLayer;

  private readonly iq: IqCanvasLayer;

  constructor(
    canvas: HTMLCanvasElement,
    quality: TvQualityConfig = getTvQualityConfig('high'),
  ) {
    this.fruit = new FruitNinjaCanvasLayer(canvas, quality);
    this.target = new TargetAttackCanvasLayer(canvas);
    this.legKick = new LegKickCanvasLayer(canvas);
    this.iq = new IqCanvasLayer(canvas);
  }

  /** Фоны/спрайты грузятся по выбору игры (старт калибровки), а не при открытии /tv. */
  preloadGameMedia(gameId: string): void {
    if (gameId === 'fruit-ninja-without-score') this.fruit.preload();
    else if (gameId === 'target-attack') this.target.preload();
    else if (gameId === 'leg-kick') this.legKick.preload();
    else if (gameId === 'iq') this.iq.preload();
  }

  setQualityConfig(q: TvQualityConfig): void {
    this.fruit.setQualityConfig(q);
  }

  triggerBombFlash(x: number, y: number): void {
    this.fruit.triggerBombFlash(x, y);
  }

  clearCanvas(): void {
    this.fruit.clearCanvas();
  }

  renderRemote(state: RemoteDisplayState): void {
    this.fruit.render(state);
  }

  renderTargetAttack(state: TargetDisplayState): void {
    this.target.render(state);
  }

  renderLegKick(state: LegKickDisplayState): void {
    this.legKick.render(state);
  }

  renderIq(state: IqDisplayState): void {
    this.iq.render(state);
  }
}
